/* eslint-disable no-unused-vars */
import { useTranslation } from 'react-i18next';

import { Can } from 'components/Can';
import { CreateCouncilForManyProjectProposal } from 'features/Council/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function CreateCouncilForManyProjectProposalPage() {
  const { t } = useTranslation();

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <Can do="create" on="council">
            <CreateCouncilForManyProjectProposal />
          </Can>
          <Can not do="create" on="council">
            <h4 className="text-red-500">{t('permission.forbid.create.council')}</h4>
          </Can>
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default CreateCouncilForManyProjectProposalPage;
